import { lazy } from 'react';

export const CustomersPage = lazy(() => import('./CustomersPage'));
export const CustomersSettingsPage = lazy(() => import('./CustomersSettingsPage'));
